<template>
  <div class="d-flex flex-column ga-8">
    <div class="display-md-light text-text-primary">{{$t('login.ClosdTagLine.header')}}</div>

    <div class="d-flex flex-column ga-5">
      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="signature" color="icon-blue" />
        </div>
        <div class="body-lg-bold text-text-primary">{{$t('login.ClosdTagLine.signature')}}</div>
      </div>

      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="shield" color="icon-blue" />
        </div>
        <div class="body-lg-bold text-text-primary">{{$t('login.ClosdTagLine.security')}}</div>
      </div>

      <div class="d-flex align-center ga-4">
        <div class="tile__visual">
          <app-material-icon name="docs" color="icon-blue" />
        </div>
        <div class="body-lg-bold text-text-primary">{{$t('login.ClosdTagLine.project')}}</div>
      </div>
    </div>
    <div class="d-flex flex-column ga-2 body-lg-regular text-text-secondary">
      <p>{{$t('login.ClosdTagLine.paragraphOne')}}</p>
      <p>{{$t('login.ClosdTagLine.paragraphTwo')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosdTagLine',
}
</script>

<style lang="scss" scoped>
@import "@/scss/border-tokens";

.tile__visual {
  background-color: rgb(var(--v-theme-surface-blue-subtle));
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  @include border-radius('border-radius-2');
  overflow: hidden;
}
</style>
